import { render, staticRenderFns } from "./attendeesList.vue?vue&type=template&id=2ff620ee&scoped=true&"
import script from "./attendeesList.vue?vue&type=script&lang=js&"
export * from "./attendeesList.vue?vue&type=script&lang=js&"
import style0 from "./attendeesList.vue?vue&type=style&index=0&id=2ff620ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff620ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff620ee')) {
      api.createRecord('2ff620ee', component.options)
    } else {
      api.reload('2ff620ee', component.options)
    }
    module.hot.accept("./attendeesList.vue?vue&type=template&id=2ff620ee&scoped=true&", function () {
      api.rerender('2ff620ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/attendeesList.vue"
export default component.exports